import React from 'react';

const App: React.FC = () => {
  return (
    <div className="App">
        <div className="privacy-policy py-5">
            <div className="container">
              <div className="">
                <h3 className="text-center fw-bold mb-4">গোপনীয়তা নীতি</h3>
                <strong>হজ ট্রাভেল প্ল্যাটফর্মের জন্য গোপনীয়তা নীতি</strong>
                <br/>
                <p>
                আপনার গোপনীয়তা আমাদের জন্য গুরুত্বপূর্ণ। এই গোপনীয়তা নীতিতে আমরা ব্যাখ্যা করব কীভাবে আমরা আপনার তথ্য সংগ্রহ, ব্যবহার, সংরক্ষণ ও সুরক্ষা প্রদান করি।
                </p>
                <p><strong>তথ্য সংগ্রহ</strong></p>
                <p>আমরা নিম্নলিখিত তথ্য সংগ্রহ করতে পারি:</p>
                <ul>
                <li>ব্যক্তিগত তথ্য (নাম, ঠিকানা, ইমেইল, ফোন নম্বর ইত্যাদি)</li>
                <li>পাসপোর্ট ও ভিসা সম্পর্কিত তথ্য</li>
                <li>অর্থপ্রদানের বিবরণ (যদি প্রযোজ্য হয়)</li>
                <li>ভ্রমণ সংক্রান্ত পছন্দ ও আগ্রহ</li>
                <li>প্রযুক্তিগত তথ্য (আইপি ঠিকানা, ব্রাউজার প্রকার, ডিভাইস তথ্য ইত্যাদি)</li>
                </ul>
                <p><strong>তথ্য ব্যবহারের উদ্দেশ্য</strong></p>
                <p>আমরা আপনার তথ্য নিম্নলিখিত উদ্দেশ্যে ব্যবহার করি:</p>
                <ul>
                <li>আপনার হজ এবং ওমরাহ ভ্রমণের বুকিং প্রক্রিয়া পরিচালনা করা </li>
                <li>কাস্টমার সার্ভিস প্রদান করা</li>
                <li>অর্থপ্রদানের নিরাপত্তা নিশ্চিত করা</li>
                <li>আইনি ও নিয়ন্ত্রক বাধ্যবাধকতা মেনে চলা</li>
                <li>ওয়েবসাইট উন্নয়নের জন্য বিশ্লেষণ পরিচালনা করা</li>
                </ul>
                <p><strong>তথ্য সুরক্ষা</strong></p>
                <p>
                আমরা আপনার তথ্য নিরাপদ রাখার জন্য উপযুক্ত প্রযুক্তিগত ও প্রশাসনিক ব্যবস্থা গ্রহণ করি। আপনার ব্যক্তিগত তথ্যের অননুমোদিত প্রবেশ, পরিবর্তন বা প্রকাশ প্রতিরোধে আমরা যথাযথ ব্যবস্থা গ্রহণ করি।
                </p>

                <strong>তৃতীয় পক্ষের সাথে তথ্য শেয়ারিং</strong>
                <br/>
                <ul className="personal_data">
                    <li>সরকারী কর্তৃপক্ষের অনুরোধে</li>
                    <li>আমাদের পরিষেবা প্রদানকারীদের সাথে, যারা আমাদের হয়ে কাজ করে</li>
                    <li>আইনি বাধ্যবাধকতা পূরণ করতে</li>
                </ul>
                <b>কুকিজ ও ট্র্যাকিং প্রযুক্তি </b>
                <br/>
                <p> আমাদের ওয়েবসাইট কুকিজ এবং অনুরূপ প্রযুক্তি ব্যবহার করে আপনার ব্রাউজিং অভিজ্ঞতা উন্নত করার জন্য। আপনি চাইলে কুকিজ ব্যবহারের অনুমতি বন্ধ করতে পারেন, তবে এটি ওয়েবসাইটের নির্দিষ্ট কার্যকারিতার উপর প্রভাব ফেলতে পারে।</p>
                <b> আপনার অধিকার </b>
                <br/>
                <p>আপনার ব্যক্তিগত তথ্য সম্পর্কে আপনার নির্দিষ্ট অধিকার রয়েছে, যার মধ্যে রয়েছে:
                </p>
                <ul>
                <li>আপনার তথ্যের অ্যাক্সেস ও সংশোধন করার অধিকার</li>
                <li>তথ্য অপসারণ বা প্রসেসিং সীমিত করার অনুরোধ</li>
                <li>মার্কেটিং সংক্রান্ত যোগাযোগ বন্ধ করার অনুরোধ</li>
                </ul>
                <strong> পরিবর্তন ও আপডেট</strong>
                <br/>
                <p> আমরা প্রয়োজন অনুসারে আমাদের গোপনীয়তা নীতি আপডেট করতে পারি। পরিবর্তনের ক্ষেত্রে আমরা ওয়েবসাইটে বিজ্ঞপ্তি প্রদান করব।</p>
              </div>
            </div>   
        </div>
    </div>
  );
}

export default App;